// 初始化时从 localStorage 读取状态
const getInitialMuteState = () => {
  const savedState = localStorage.getItem("game_isMuted");
  return savedState !== null ? JSON.parse(savedState) : false;
};

const state = {
  status: "ready", // ready|start|pause|fail|win
  isMuted: getInitialMuteState(),
  lastUpdate: null,
};
const mutations = {
  SET_STATUS(state, status) {
    state.status = status;
    state.lastUpdate = Date.now();
    // 状态转换验证
    // const validTransitions = {
    //   ready: ["start"],
    //   start: ["pause", "fail", "win"],
    //   pause: ["start"],
    //   fail: ["ready", "start"],
    //   win: ["ready", "start"],
    // };

    // if (validTransitions[state.status].includes(status)) {
    //   state.status = status;
    //   state.lastUpdate = Date.now();
    // } else {
    //   console.warn(`Invalid status transition: ${state.status} → ${status}`);
    // }
  },
  SET_MUTE(state) {
    state.isMuted = !state.isMuted;
    // 将状态保存到 localStorage
    localStorage.setItem("game_isMuted", JSON.stringify(state.isMuted));
  },
};
const getters = {
  gameDuration: (state) => {
    return state.lastUpdate
      ? Math.floor((Date.now() - state.lastUpdate) / 1000)
      : 0;
  },
  isRunning: (state) => state.status === "start" || state.status === "pause",
};
const actions = {
  startGame({ commit }) {
    commit("SET_STATUS", "start");
  },
  pauseGame({ commit, state }) {
    if (state.status === "start") {
      commit("SET_STATUS", "pause");
    }
  },
  resumeGame({ commit, state }) {
    if (state.status === "pause") {
      commit("SET_STATUS", "start");
    }
  },
  gameOver({ commit }, isWin) {
    console.log("weinwienwienweniw");
    commit("SET_STATUS", isWin ? "win" : "fail");
  },
  resetGame({ commit }) {
    commit("SET_STATUS", "start");
  },
  readyGame({ commit }) {
    commit("SET_STATUS", "ready");
  },
  mute({ commit }) {
    commit("SET_MUTE");
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
